import { render, staticRenderFns } from "./AdminCalendars.vue?vue&type=template&id=146cc855"
import script from "./AdminCalendars.vue?vue&type=script&lang=js"
export * from "./AdminCalendars.vue?vue&type=script&lang=js"
import style0 from "./AdminCalendars.vue?vue&type=style&index=0&id=146cc855&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports